import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 契約者コースプラン取得
 */
export namespace ApiTaTp030 {
  // API Name
  export const name: string = 'ApiTaTp030'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/contractorCoursePlan'

    export interface Request {
      query: {
        planId: string
      }
    }

    export interface Response {
      courseId: string
      planId: string
      levelId: string
      coursePlanId: string
    }
  }

  // API本体
  export class Api
    extends ApiBase
    implements Gettable<Get.Request, Get.Response, ResponseError>
  {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        courseId: '',
        planId: '',
        levelId: '',
        coursePlanId: '',
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
